import styled from 'styled-components'
import { breakpoint } from '@sketch/global-styles'
import { Text } from '@sketch/components'

export const SearchBarWrapper = styled.div`
  min-width: 320px;
  width: 100%;
  margin-left: 8px;
  margin-right: 24px;

  ${breakpoint('md')`
    width: 480px;
  `}

  form {
    max-width: initial;
  }
`

export const ViewAsText = styled(Text.Span).attrs({
  textStyle: 'copy.quaternary.standard.D',
})`
  flex-shrink: 0;
  margin-right: 8px;
`
